<!--  Slider Image   -->
<div class="row m-b-sm">
    <div class="col-md-4">
        <label>Slider Image</label>
    </div>
    <div class="col-md-8" *ngIf="!pageData.sliderImage">
        <website-builder-image-upload (imageUpload)="pageData.sliderImage = $event"></website-builder-image-upload>
    </div>
    <div class="col-md-4" *ngIf="pageData.sliderImage">
        <div class="image-wrapper">
            <img [src]="pageData.sliderImage" />
            <div class="remove-image">
                <i class="fa fa-times-circle fa-2x"
                   aria-hidden="true"
                   (click)="pageData.sliderImage = null">
                </i>
            </div>
        </div>
    </div>
</div>

<!--  Headline   -->
<div class="row m-b-sm">
    <div class="col-md-4">
        <label>Headline</label>
    </div>
    <div class="col-md-8">
        <textarea [(ngModel)]="pageData.headline" class="form-control" name="headline" resizable="false" maxlength="150"></textarea>
        <span class="number-of-allowed-chars">{{pageData.headline.length}} / 150 Chars</span>
    </div>
</div>

<!--  Text   -->
<div class="row m-b-sm">
    <div class="col-md-4">
        <label>Text</label>
    </div>
    <div class="col-md-8">
        <textarea [(ngModel)]="pageData.text" class="form-control" name="text" resizable="false" maxlength="150"></textarea>
        <span class="number-of-allowed-chars">{{pageData.text.length}} / 150 Chars</span>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/website-builder/website-builder-side-editor/section/wb-edit-top-banner/wb-edit-top-banner.component.html